import vtkCircleContextRepresentation from './CircleContextRepresentation';
import vtkContextRepresentation from './ContextRepresentation';
import vtkConvexFaceContextRepresentation from './ConvexFaceContextRepresentation';
import vtkCubeHandleRepresentation from './CubeHandleRepresentation';
import vtkHandleRepresentation from './HandleRepresentation';
import vtkImplicitPlaneRepresentation from './ImplicitPlaneRepresentation';
import vtkOutlineContextRepresentation from './OutlineContextRepresentation';
import vtkPolyLineRepresentation from './PolyLineRepresentation';
import vtkSphereHandleRepresentation from './SphereHandleRepresentation';
import vtkWidgetRepresentation from './WidgetRepresentation';

export default {
  vtkCircleContextRepresentation,
  vtkContextRepresentation,
  vtkConvexFaceContextRepresentation,
  vtkCubeHandleRepresentation,
  vtkHandleRepresentation,
  vtkImplicitPlaneRepresentation,
  vtkOutlineContextRepresentation,
  vtkPolyLineRepresentation,
  vtkSphereHandleRepresentation,
  vtkWidgetRepresentation,
};
